module.exports = __webpack_public_path__ + "static/media/info_325.2762fcfb.pdf";